import { CalendarMonth } from '@mui/icons-material';
import { Box, Paper } from '@mui/material';
import React from 'react';

import { Button } from '@/components/Button';

import type { CalDavRequiredOverlayProps } from '../../types';

import s from './CalDavRequiredOverlay.module.scss';

const CalDavRequiredOverlay: React.FC<CalDavRequiredOverlayProps> = ({ onSettingsClick }) => {
  return (
    <Box className={s.overlay}>
      <Paper className={s.overlay__modal} elevation={3}>
        <CalendarMonth className={s.overlay__icon} />
        <h2 className={s.overlay__title}>Настройте CalDAV</h2>
        <p className={s.overlay__description}>
          Для просмотра событий календаря необходимо настроить интеграцию с CalDAV сервером.
        </p>
        <Button variant="contained" onClick={onSettingsClick}>
          Перейти к настройкам
        </Button>
      </Paper>
    </Box>
  );
};

export { CalDavRequiredOverlay };
